const PAQO = 'plone.app.querystring.operation';

const deserializeQuery = (q) => {
  return JSON.parse(q)?.map((kvp) => ({
    ...kvp,
    o: kvp.o.replace(/^paqo/, PAQO),
  }));
};

export function mergeQuery(location, query) {
  const qs = Object.fromEntries(new URLSearchParams(location.search));
  const urlQuery = { query: qs?.query ? deserializeQuery(qs['query']) : {} };
  return { ...query, ...urlQuery };
}
